import React from 'react'
import './SomeQuotes.css'

const SomeQuotes = () => {
    return (
        <div className="some-quotes">
            <q className="some-quotes-q">
                The pillar of any company that deals with logistics is the ability to deliver on time with minimal risk of loss
            </q>
        </div>
    )
}

export default SomeQuotes
